import ExpoRandom from './ExpoBIP39';

export default ExpoRandom;
